import type { SignInOption } from '@sequencehq/core-components'
import type { SSOActiveConnection } from '@stytch/react/b2b'

/** Stytch's `identity_provider` is a slug; these are how we spell them. */
const PROVIDER_NAMES: Record<string, string> = {
  okta: 'Okta',
  'microsoft-entra': 'Microsoft Entra',
  google: 'Google Workspace',
  'generic-saml': 'SAML',
  'generic-oidc': 'OIDC'
}

/**
 * `display_name` is set per connection in Stytch and may be blank, so the
 * provider stands in. Sorted by label: Stytch promises no order.
 */
export const toSignInOptions = (
  connections: SSOActiveConnection[] | undefined
): SignInOption[] =>
  (connections ?? [])
    .map(connection => ({
      id: connection.connection_id,
      label:
        connection.display_name.trim() ||
        PROVIDER_NAMES[connection.identity_provider] ||
        connection.identity_provider
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
